webpackJsonp([194117863437379],{

/***/ 89:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var fadeIn = exports.fadeIn = {
	  from: { opacity: 0 },
	  to: { opacity: 1 }
	};
	
	var fadeInLeft = exports.fadeInLeft = {
	  from: { x: 50, opacity: 0 },
	  to: { x: 0, opacity: 1 }
	};
	
	var fadeInUp = exports.fadeInUp = {
	  from: { y: 50, opacity: 0 },
	  to: { y: 0, opacity: 1 }
	};
	
	var fadeInRight = exports.fadeInRight = {
	  from: { x: -50, opacity: 0 },
	  to: { x: 0, opacity: 1 }
	};
	
	var scaleIn = exports.scaleIn = {
	  from: { scaleX: 0.5, opacity: 0 },
	  to: { scaleX: 1, opacity: 1 }
	};
	
	var imageLeft = exports.imageLeft = {
	  from: { transformPerspective: 1000, rotationY: 40, x: '-50%', z: -500, transformOrigin: 'right', opacity: 0 },
	  to: { transformPerspective: 1000, rotationY: 0, x: '0%', z: 0, transformOrigin: 'right', opacity: 1 }
	};
	
	var imageRight = exports.imageRight = {
	  from: { transformPerspective: 1000, rotationY: 40, x: '50%', z: -500, transformOrigin: 'left', opacity: 0 },
	  to: { transformPerspective: 1000, rotationY: 0, x: '0%', z: 0, transformOrigin: 'left', opacity: 1 }
	};
	
	var sgTopFade = exports.sgTopFade = {
	  from: { transformPerspective: 500, rotationX: 20, transformOrigin: "center top", opacity: 0, ease: Power2.easeOut },
	  to: { rotationX: 0, opacity: 1 }
	};

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2, _class2, _temp3;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(66);
	
	var _scrollmagic = __webpack_require__(23);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animations = __webpack_require__(89);
	
	var animations = _interopRequireWildcard(_animations);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/no-find-dom-node */
	
	var AnimationScroll = (_temp2 = _class = function (_Component) {
	  _inherits(AnimationScroll, _Component);
	
	  function AnimationScroll() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AnimationScroll);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.animRefs = [], _this.scenes = [], _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  AnimationScroll.prototype.componentWillMount = function componentWillMount() {
	    AnimationScroll.count++;
	    this.count = AnimationScroll.count;
	  };
	
	  AnimationScroll.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var duration = this.props.duration;
	
	    var types = this.props.types.replace(/ /g, '').split(',');
	
	    this.animRefs.forEach(function (ref, index) {
	      var node = (0, _reactDom.findDOMNode)(ref);
	      var delay = window.innerWidth < 640 ? 0 : _this2.props.delay;
	      var type = types[index] || types[types.length - 1];
	      var animation = TweenMax.fromTo(node, duration, animations[type].from, animations[type].to).pause().delay(delay * index);
	
	      var scene = new _scrollmagic.Scene({
	        triggerElement: node,
	        triggerHook: 0.6
	      });
	      var indicatorName = 'Scrollanimation ' + _this2.count + '.' + index;
	      scene.on('enter', function () {
	        return animation.play();
	      });
	
	      if (false) {
	        scene.addIndicators({ name: indicatorName });
	      }
	
	      scene.addTo(_this2.context.scrollmagic);
	      _this2.scenes.push(scene);
	    });
	  };
	
	  AnimationScroll.prototype.componentWillUnmount = function componentWillUnmount() {
	    AnimationScroll.count--;
	    this.scenes.forEach(function (scene) {
	      scene.destroy();
	    });
	  };
	
	  AnimationScroll.prototype.render = function render() {
	    return this.children;
	  };
	
	  _createClass(AnimationScroll, [{
	    key: 'children',
	    get: function get() {
	      var _this3 = this;
	
	      return _react.Children.map(this.props.children, function (child, key) {
	        return _react2.default.createElement(
	          RefWrapper,
	          { key: key, ref: function ref(c) {
	              _this3.animRefs.push(c);
	            } },
	          child
	        );
	      });
	    }
	  }]);
	
	  return AnimationScroll;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.node,
	  duration: _propTypes2.default.number,
	  delay: _propTypes2.default.number,
	  types: _propTypes2.default.string
	}, _class.defaultProps = {
	  duration: 0.5,
	  delay: 0,
	  types: 'fadeIn'
	}, _class.contextTypes = {
	  scrollmagic: _propTypes2.default.any
	}, _class.count = 0, _temp2);
	exports.default = AnimationScroll;
	var RefWrapper = (_temp3 = _class2 = function (_Component2) {
	  _inherits(RefWrapper, _Component2);
	
	  function RefWrapper() {
	    _classCallCheck(this, RefWrapper);
	
	    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
	  }
	
	  RefWrapper.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RefWrapper;
	}(_react.Component), _class2.propTypes = {
	  children: _propTypes2.default.node
	}, _temp3);
	module.exports = exports['default'];

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(41);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _gsap = __webpack_require__(39);
	
	__webpack_require__(883);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CatProduct = function (_Component) {
	    _inherits(CatProduct, _Component);
	
	    function CatProduct() {
	        _classCallCheck(this, CatProduct);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    CatProduct.prototype.onMouseOverHandle = function onMouseOverHandle(product) {
	        //console.log(this.img)
	        _gsap.TweenMax.to(this.img, 0.4, { scale: 1.1 });
	        //TweenMax.to(this.imgContainer, 0.4, { clipPath:'inset(10px)', webKitClipPath:'inset(10px)',  ease: Power2.easeInOut });
	    };
	
	    CatProduct.prototype.onMouseLeaveHandle = function onMouseLeaveHandle() {
	        _gsap.TweenMax.to(this.img, 0.4, { scale: 1 });
	        //TweenMax.to(this.imgContainer, 0.4, { clipPath:'inset(0px)', webKitClipPath:'inset(0px)',  ease: Power2.easeInOut });
	    };
	
	    CatProduct.prototype.render = function render() {
	        var _this2 = this;
	
	        var product = this.props.product;
	        return _react2.default.createElement(
	            'div',
	            { key: product.node.id, className: 'col-md-6' },
	            _react2.default.createElement(
	                _Link2.default,
	                { ref: function ref(e) {
	                        return _this2.container = e;
	                    }, onMouseLeave: function onMouseLeave() {
	                        return _this2.onMouseLeaveHandle();
	                    }, onMouseEnter: function onMouseEnter() {
	                        return _this2.onMouseOverHandle();
	                    }, to: '/case-study/' + product.node.slug, className: 'cs-product' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'cs-product--product-image', ref: function ref(e) {
	                            return _this2.imgContainer = e;
	                        } },
	                    product.node.featured_media ? _react2.default.createElement('img', { 'class': 'cs-project-img', key: product.node.id, ref: function ref(e) {
	                            return _this2.img = e;
	                        }, src: product.node.featured_media.source_url }) : null
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { ref: function ref(e) {
	                            return _this2.detailsContainer = e;
	                        }, className: 'cs-product--product-details' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'project-detail-title home-recent--project--details--name' },
	                        _react2.default.createElement('span', { className: 'bg-block--container' }),
	                        _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: product.node.title } })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'project-details.type home-recent--project--details--type' },
	                        _react2.default.createElement('span', { className: 'bg-block--container' }),
	                        this.props.cat.name
	                    )
	                )
	            )
	        );
	    };
	
	    return CatProduct;
	}(_react.Component);
	
	exports.default = CatProduct;
	module.exports = exports['default'];

/***/ }),

/***/ 883:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _class, _temp;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(191);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A <Link /> is used an enhanced React Router Link. This Component
	 * will render a plain anchor tag when the Link is external. This
	 * Link will also prefetch anything in getComponent for a given route.
	 * This provides a smoother experience for the user.
	 *
	 */
	var Link = (_temp = _class = function (_Component) {
	  _inherits(Link, _Component);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        rest = _objectWithoutProperties(_props, ['children']);
	
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      rest,
	      children
	    );
	  };
	
	  return Link;
	}(_react.Component), _class.propTypes = {
	  children: _propTypes2.default.node,
	  to: _propTypes2.default.string
	}, _temp);
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = exports.default = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(41);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _gsap = __webpack_require__(39);
	
	var _CatProduct = __webpack_require__(372);
	
	var _CatProduct2 = _interopRequireDefault(_CatProduct);
	
	var _Helmet = __webpack_require__(92);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	var _AnimationScroll = __webpack_require__(90);
	
	var _AnimationScroll2 = _interopRequireDefault(_AnimationScroll);
	
	__webpack_require__(891);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Category = function (_Component) {
	    _inherits(Category, _Component);
	
	    function Category() {
	        _classCallCheck(this, Category);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    Category.prototype.onMouseOverHandle = function onMouseOverHandle(product) {
	        //console.log(this.img)
	    };
	
	    Category.prototype.onMouseLeaveHandle = function onMouseLeaveHandle() {
	        //TweenMax.to(this.img, 0.4, { scale:1 })
	    };
	
	    Category.prototype.componentDidMount = function componentDidMount() {
	        // TweenMax.set(this.img, { scale:1 })
	    };
	
	    Category.prototype.render = function render() {
	        var _this2 = this;
	
	        console.log(this.props);
	        return _react2.default.createElement(
	            'div',
	            { style: { height: '100%' } },
	            _react2.default.createElement(_Helmet2.default, {
	                title: this.props.pathContext.name + ' //// Studio Gritt',
	                description: this.props.pathContext.description,
	                image: 'https://studiogritt.files.wordpress.com/2018/04/141.jpg'
	            }),
	            _react2.default.createElement(
	                'section',
	                { className: 'pageSection' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'pageHeading' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        this.props.pathContext.slug === 'blogs' ? null : _react2.default.createElement(
	                            'h5',
	                            null,
	                            'Case Studies'
	                        ),
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            this.props.pathContext.name
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            { style: { fontSize: '2rem' } },
	                            this.props.pathContext.description
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { className: 'case-study-section product-list' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            this.props.data.allWordpressPost ? this.props.data.allWordpressPost.edges.map(function (product) {
	
	                                return _react2.default.createElement(_CatProduct2.default, { cat: _this2.props.pathContext, product: product });
	                            }) : _react2.default.createElement(
	                                'div',
	                                null,
	                                'No Products Found'
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return Category;
	}(_react.Component);
	
	exports.default = Category;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 891:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-category-index-js-911a6bd1f8b240c3a6ff.js